import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

type Props = {
  label: string;
  onSelect: (checked: boolean) => void;
  selected?: boolean;
  disabled?: boolean;
};

const CheckButton = (props: Props) => {
  const uniqueId = `${props.label.replace(/\s+/g, "-")}-checkbox`;

  return (
    <div
      className={`flex-grow flex flex-row space-x-2 items-center ${
        props.disabled ? "opacity-50" : ""
      }`}
    >
      <Label
        htmlFor={uniqueId}
        className={`flex-grow bg-gray-drk shadow-basic flex justify-center items-center h-full p-1 ${
          props.disabled ? "" : "cursor-pointer"
        }`}
      >
        {props.label}
      </Label>

      <div className="flex-shrink-0">
        <Checkbox
          id={uniqueId}
          checked={props.selected}
          onCheckedChange={(checked) => props.onSelect(checked as boolean)}
          disabled={props.disabled}
          className="h-6 w-6"
        />
      </div>
    </div>
  );
};

export default CheckButton;
